
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/promo/crypto",
      function () {
        return require("private-next-pages/[locale]/promo/crypto/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/promo/crypto"])
      });
    }
  